import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getGolfSchools } from './actions';
import GolfSchoolClasses from './GolfSchoolClasses';
import GolfSchoolsListPage from './GolfSchoolsListPage';
import Loading from '../common/components/Loading';

class GolfSchools extends Component {
  componentDidMount() {
    this.props.dispatch(getGolfSchools());
  }

  render() {
    const { match, loaded } = this.props;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={GolfSchoolsListPage} />
        <Route path={`${match.path}/:schoolId`} component={GolfSchoolClasses} />
        <Redirect to={`${match.path}`} />
      </Switch>
    );
  }
}

const mapStateToProps = state => {
  return {
    loaded: state.golfSchools.schools.get('loaded'),
  };
};

export default connect(mapStateToProps)(GolfSchools);



// WEBPACK FOOTER //
// ./src/golf-schools/GolfSchools.js